/* eslint-disable security/detect-object-injection */

/* eslint-disable max-len */
import React,{useState,useContext, useEffect,useCallback,} from "react"
import SetGlobalVariables from './Components/SetGlobalVariables'
import VitalInformation from './Components/VitalInformation'
import TopHeader from '../../components/TopHeader'
import GlobalContext from "../../components/Context/GloablContext"
import { dataService } from "../../services/data.services"
import Loader from "../../components/Loader/index"
import { handleSystemConfig } from "../../redux/systemConfigSlice"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import {validateEmail} from "../../CommonMethods/EmailValidator"
import {motion} from 'framer-motion'
import { useDispatch } from "react-redux"
import CustomOverLay from "../../components/CustomOverLay"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import { phoneCodeArray } from "../../CommonMethods/phoneNumberCountryCodes"

export default function SystemConfiguration() {
    const {confirmationStateCancel,setConfirmationStateCancel,confirmationState,setConfirmationState,setToastmessage, initialRoutePath,setInitialRoutePath,setToastErrorMessage,isSideBar} =useContext(GlobalContext)
    const [emptyField, setEmptyField] = useState(false)
    const dispatch=useDispatch()
    const location=useLocation()
    const navigate=useNavigate()
    const [loading,setLoading]=useState(true)
    const [emailError,setEmailError]=useState(false)
    const [getAPIid,setGetAPIid]=useState({})
    const [getData,setGetData]=useState()
    const [sessionError,setSessionError]=useState(false)
    const [maxFailError,setMaxFailError]=useState(false)
    const [type,setType]=useState("view")
    const [isDisableCancel,setIsDisableCancel]=useState(true)
    const [vitalInfoFields,setVitalInfoFields]=useState({
        "blood_glucose":"",
        "blood_pressure":"",
        "temperature":"",
        "spo2":"",
        "pulse":"",
        "weight":"",
        "height":""
    })

    const [globalVariables,setGlobalVariables]=useState({
        "date_format":"",
        "country_code":"",
        "max_file_size":"",
        "email_addr":"",
        "session_timeout":"",
        "public_encryp_key":"",
        "browser_trust_duration":"",
        "temp_pass_duration":"",
        "recent_otp_durn":"",
        "max_failed_attempts":"",
        "otp_validity_durn":""
    })
   
    const [toggleValues,setToggleValues]=useState({
        "enforce_otp_verification":false,
        "forget_password_admin_users":false

    })
 
    useEffect(()=>{
        if(type==="add"){
            setLoading(false)
        }
        if(type==="view"){
            fetchSystemConfigData()
        }
    },[type])

    // useEffect(()=>{

    //     if(!location.pathname.includes('system-configuration')){
    //         navigate('/system-configuration')
    //     }
    // },[])
    
    const handleOnChangeToggle=(id)=>{
        setIsDisableCancel(false)
        setToggleValues((prev)=>({
            ...prev,
            [id]:!toggleValues[id]

        }))

     
    }

    const handleFetchSystemConfig = async() =>{
        try{
            setLoading(true)
            let response
            response = await dataService.GetAPI(`system-configuration?admin=true`);
            if(response.data.status===200){
                if(response?.data?.data===null){
                    setType("add")
                    return
                }
                setGetAPIid(response.data.data._id)
                setGetData(response.data.data)
                setLoading(false)
                dispatch(handleSystemConfig(response.data.data))
                const Getdata=response.data.data
                //sessionStorage.setItem('date-format',Getdata?.global_variables?.date_format)
                let tempDisp=""
                if(Getdata?.vital_information?.temperature==="C"){
                    tempDisp="℃"
                }
                else{
                    tempDisp="℉"
                }
                setGlobalVariables((prev)=>({
                    ...prev,
                    "date_format":Getdata?.global_variables?.date_format,
                    "country_code":Getdata?.global_variables?.country_code,
                    "max_file_size":Getdata?.global_variables?.maximum_file_size,
                    "email_addr":Getdata?.global_variables?.email_address,
                    "session_timeout":Getdata?.global_variables?.session_timeout,
                    "public_encryp_key":Getdata?.global_variables?.public_encryption_key,
                    "browser_trust_duration":Getdata?.global_variables?.browser_trust_duration,
                    "temp_pass_duration":Getdata?.global_variables?.temporary_password_expiry_duration,
                    "recent_otp_durn":Getdata?.global_variables?.resend_otp_duration,
                    "max_failed_attempts":Getdata?.global_variables?.max_failed_login_attempts,
                    "otp_validity_durn":Getdata?.global_variables?.otp_validity_duration
    
                }))
                setVitalInfoFields((prev)=>({
                    ...prev,
                    "blood_glucose":Getdata?.vital_information?.blood_glucose,
                    "blood_pressure":Getdata?.vital_information?.blood_pressure,
                    "temperature":tempDisp,
                    "spo2":Getdata?.vital_information?.SP02,
                    "pulse":Getdata?.vital_information?.pulse,
                    "weight":Getdata?.vital_information?.weight,
                    "height":Getdata?.vital_information?.height
                }))
                setToggleValues((prev)=>({
                    ...prev,
                    "enforce_otp_verification":Getdata?.enforce_otp_verification,
                    "forget_password_admin_users":Getdata?.allow_forgot_password_admin
                }))
            }else{
    
            }

        }catch(err){
            
            if(err?.code==="ERR_NETWORK"){
                handleFetchSystemConfig()
            }
        }
       
    }
    
    const fetchSystemConfigData=useCallback(async()=>{
        handleFetchSystemConfig()
        
        
    } ,[setGetAPIid,setToggleValues,setVitalInfoFields,setGlobalVariables,dataService])

    const handleSubmit=()=>{
        const hasEmptyFields = (...objects) => {
            
            for (const obj of objects) {
                for (let key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        const value = obj[key];
                        if (value === null || value === undefined || value.toString()?.trim() === ''||(key==="public_encryp_key"&&value.replace(/(\r\n|\n|\r)/gm, "").trim())==="") {
                            return true; // Found an empty value in one of the objects
                        }
                    }
                }
            }
            return false;
        };
        if (hasEmptyFields(globalVariables,vitalInfoFields)) {
           
            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        }
        if(validateEmail(globalVariables?.email_addr?.trim())) {  
            setEmailError(true)
            setLoading(false);
            return

        }
        if(parseInt(globalVariables?.session_timeout)<60){
            setLoading(false)
            setSessionError(true)
            setToastErrorMessage('Minimum of 60 minutes is required')
            return

        }
        if(parseInt(globalVariables?.max_failed_attempts)>=6){
            setLoading(false)
            setMaxFailError(true)
            setToastErrorMessage('Maximum of 5 login attempts allowed')
            return
        }
        else{
            setConfirmationState(true)
        }
        

    }
    const handleAddSystemConfig=async(type)=>{
       
        
       
        try {
            let val
            if(vitalInfoFields.temperature==="℃"){
                val="C"
            }
            else{
                val="F"
            }
            let response = null
            let body = {
                global_variables: {
                    date_format: globalVariables?.date_format,
                    country_code: globalVariables?.country_code.trim(),
                    session_timeout: parseInt(globalVariables?.session_timeout),
                    maximum_file_size: parseInt(globalVariables?.max_file_size),
                    email_address: globalVariables?.email_addr,
                    browser_trust_duration: globalVariables?.browser_trust_duration,
                    otp_validity_duration: globalVariables?.otp_validity_durn,
                    resend_otp_duration: globalVariables?.recent_otp_durn,
                    temporary_password_expiry_duration: globalVariables?.temp_pass_duration,
                    max_failed_login_attempts: parseInt(globalVariables?.max_failed_attempts),
                    public_encryption_key: globalVariables?.public_encryp_key
                },
                vital_information: {
                    blood_glucose: vitalInfoFields.blood_glucose,
                    blood_pressure: vitalInfoFields.blood_pressure,
                    temperature: val,
                    SP02: vitalInfoFields.spo2,
                    pulse: vitalInfoFields.pulse.toLowerCase(),
                    weight: vitalInfoFields.weight,
                    height: vitalInfoFields.height
                },
                enforce_otp_verification: toggleValues.enforce_otp_verification,
                allow_forgot_password_admin: toggleValues.forget_password_admin_users
            }
            if(type==="add"){
                setLoading(true)
                response = await dataService.PostAPI(body, `system-configuration`);
               
                setToastmessage(response?.data.data?.message);
                //dispatch(handleIsAPICall(true))
                setType("view")
            }
            
            else if(type==="edit"){
                setLoading(true)
                response = await dataService.PatchAPI(body, `system-configuration/${getAPIid}`);
                //dispatch(handleIsAPICall(true))
                setToastmessage('Global variables updated successfully');
                setType("view")
            }
           
           
        } catch (error) {
            setConfirmationState(false)
            setLoading(false);    
        }

    }
    
    
    return (
        <>
            <TopHeader title={"System Configuration"}/>
            {loading?<CustomOverLay Active text="Loading System Configuration details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:<>
                <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                    <div className='bg-white rounded-lg py-[10px] pl-[35px] pr-3 2xl:pr-[42px]'>
                        <div className='pr-[22px] h-customh2 overflow-auto overflow-x-hidden scrollbar_purple'>
                            <motion.div 
                                className="border border-[#D0D5DD] p-4 mt-1"
                                animate={{ x: 0 }}
                                initial={{ x: 0 }}
                                transition={{duration:0.5}}
                            >
                                <SetGlobalVariables 
                                    type={type}
                                    setType={setType}
                                    emptyField={emptyField} 
                                    setEmptyField={setEmptyField} 
                                    globalVariables={globalVariables}
                                    setGlobalVariables={setGlobalVariables}
                                    emailError={emailError}
                                    setEmailError={setEmailError}
                                    sessionError={sessionError}
                                    setSessionError={setSessionError}
                                    maxFailError={maxFailError}
                                    setMaxFailError={setMaxFailError}
                                    countryCodes={phoneCodeArray}
                                    setIsDisableCancel={setIsDisableCancel}
                                    handleAddSystemConfig={handleAddSystemConfig}
                                />
                                <VitalInformation 
                                    type={type}
                                    setType={setType} 
                                    emptyField={emptyField}
                                    setEmptyField={setEmptyField}
                                    vitalInfoFields={vitalInfoFields}
                                    setIsDisableCancel={setIsDisableCancel}
                                    setVitalInfoFields={setVitalInfoFields} />

                            </motion.div>
                        </div>
                        <div className='flex items-center justify-between mt-2 flex-wrap'>
                            <div className='flex items-center pb-3'>
                                <div className="status custom-toggle flex items-center">
                                    <p className="text-sm font-normal text-[#000000] disable_switch mr-4">Enforce OTP Verification</p> 
                                    <label className="switch" style={{marginLeft: '10px'}}>
                                        <input type="checkbox"  onChange={(e)=>{
                                            handleOnChangeToggle("enforce_otp_verification")
                                        }}id="enforce_otp_verification"  checked={toggleValues?.enforce_otp_verification} disabled={type==="view"}/><span id="enforce_otp_verificationn" className={`slider round ${type==='view'?'slider1':''}`}></span>
                                    </label>
                                </div>   
                                <div className="status custom-toggle flex items-center xl:ml-[84px] ml-[50px]">
                                    <p className="text-sm font-normal text-[#000000] disable_switch mr-4">
                                        Allow Forgot Password for Admin Users
                                    </p> 
                                    <label className="switch" style={{marginLeft: '10px'}}>
                                        <input type="checkbox" id="forget_password_admin_users" onChange={(e)=>{
                                            handleOnChangeToggle("forget_password_admin_users")
                                        }} checked={toggleValues?.forget_password_admin_users} disabled={type==="view"}/><span className={`slider round ${type==='view'?'slider1':''}`}></span>
                                    </label>
                                </div>                                   
                            </div>
                            <div className="flex justify-end lg:w-fit w-full pb-3">
                                <button type='button'
                                    id="cancel"
                                    onClick={() => setConfirmationStateCancel(true)}
                                    disabled={isDisableCancel}
                                    className={` px-4 py-2.5 mr-5 text-lg font-semibold disabled:opacity-50 text-[#972E4C] border border-[#972E4C] rounded-[16px] mt-2.5 xl:w-[148px] w-[130px]
                                            bg-[#fff] hover:bg-[#fff] focus:bg-[#fff] ${type==="view"?"hidden":""}`}>
                                    {"Cancel"}
                                </button>
                                <button type='button'
                                    id="update"
                                    onClick={() => handleSubmit()}
                                    disabled={loading}
                              
                                    className={`px-2.5 py-2.5 mr-5 text-lg font-semibold disabled:bg-[#777C88] text-[#fff] border border-[#972E4C] rounded-[16px] mt-2.5 xl:w-[148px] w-[130px]
                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] ${type==="view"?"hidden":""}`}>
                                    {type==="add"?"Save":"Update"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                        
            </>}
            {(confirmationState||confirmationStateCancel) &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                              
                        handleOnCLickActivate={confirmationState? ()=>{ setConfirmationState(false),handleAddSystemConfig(type)}:()=>{setConfirmationStateCancel(false),setGlobalVariables((prev)=>({
                            ...prev,
                            "date_format":getData?.global_variables?.date_format,
                            "country_code":getData?.global_variables?.country_code,
                            "max_file_size":getData?.global_variables?.maximum_file_size,
                            "email_addr":getData?.global_variables?.email_address,
                            "session_timeout":getData?.global_variables?.session_timeout,
                            "public_encryp_key":getData?.global_variables?.public_encryption_key,
                            "browser_trust_duration":getData?.global_variables?.browser_trust_duration,
                            "temp_pass_duration":getData?.global_variables?.temporary_password_expiry_duration,
                            "recent_otp_durn":getData?.global_variables?.resend_otp_duration,
                            "max_failed_attempts":getData?.global_variables?.max_failed_login_attempts,
                            "otp_validity_durn":getData?.global_variables?.otp_validity_duration

                        }))
                        setVitalInfoFields((prev)=>({
                            ...prev,
                            "blood_glucose":getData?.vital_information?.blood_glucose,
                            "blood_pressure":getData?.vital_information?.blood_pressure,
                            "temperature":getData?.vital_information?.temperature==="C"?"℃":"℉",
                            "spo2":getData?.vital_information?.SP02,
                            "pulse":getData?.vital_information?.pulse,
                            "weight":getData?.vital_information?.weight,
                            "height":getData?.vital_information?.height
                        }))
                        setToggleValues((prev)=>({
                            ...prev,
                            "enforce_otp_verification":getData?.enforce_otp_verification,
                            "forget_password_admin_users":getData?.allow_forgot_password_admin
                        }))}}
                        handleClose={confirmationState?()=>{setConfirmationState(false)}:()=>{setConfirmationStateCancel(false)}}
                        data-testid="confirm-btn"
                        disabled={loading}
                        tittle={confirmationStateCancel?'Cancel':`${type==="edit"?'Update':'Add'}  System Configuration`}
                        message={confirmationState?`Are you sure you want to ${type==="edit"?'Update':'Add '} System Configuration?`:'Are you sure you want to cancel the changes?'}
                        buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                        CancelButton={'No'}

                    />
                }
            />
            }
           
            
        </>
        
    )
}
